import { FC, useEffect } from 'react';
import { FormState, UseFormRegister } from 'react-hook-form';

import { useEditStore, useContractListStore } from 'page/CustomerPage/hooks';
import { InputModalView } from 'page/CustomerPage/containers/EditModal/InputModal/inputModalView';
import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { Channel } from 'types/customer';

type Props = {
  watchChannel: Channel;
  watchStatus: boolean;
  watchEnableVerticalPodAutoScaler: boolean;
  formState: FormState<CustomerFormFields>;
  register: UseFormRegister<CustomerFormFields>;
  handleClose: () => void;
  handleClickGoDelete: () => void;
  handleClickGoConfirmation: () => void;
};

export const InputModal: FC<Props> = ({
  watchChannel,
  watchStatus,
  watchEnableVerticalPodAutoScaler,
  formState,
  register,
  handleClose,
  handleClickGoDelete,
  handleClickGoConfirmation,
}) => {
  const {
    isOpenInputModal,
    id,
    zeusToken,
    zeusTokenCreatedAt,
    zeusTokenExpired,
    fetchCustomer,
  } = useEditStore();

  const { selectedContract } = useContractListStore();

  // 編集対象の顧客の詳細を取得する
  useEffect(() => {
    if (isOpenInputModal && !id) {
      void fetchCustomer();
    }
  }, [isOpenInputModal, id, fetchCustomer]);

  /** 確認ボタンの非活性状態 */
  const isConfirmButtonDisabled = !formState.isValid;

  /** 削除ボタンの非活性状態 */
  const isDeleteButtonDisabled = Boolean(selectedContract?.id);

  return (
    <>
      {/* 入力モーダル */}
      <InputModalView
        id={id}
        zeusToken={zeusToken}
        zeusTokenCreatedAt={zeusTokenCreatedAt}
        zeusTokenExpired={zeusTokenExpired}
        watchChannel={watchChannel}
        watchStatus={watchStatus}
        watchEnableVerticalPodAutoScaler={watchEnableVerticalPodAutoScaler}
        formState={formState}
        isOpen={isOpenInputModal}
        isConfirmButtonDisabled={isConfirmButtonDisabled}
        isDeleteButtonDisabled={isDeleteButtonDisabled}
        register={register}
        handleClose={handleClose}
        handleClickGoDelete={handleClickGoDelete}
        handleClickGoConfirmation={handleClickGoConfirmation}
      />
    </>
  );
};
